module.exports = __webpack_public_path__ + "img/arrow_right.3f434db7.svg";